module.exports = __webpack_public_path__ + "fonts/fa-solid-900.c6ec080.woff";